export const EMPTY_TOAST = {
  hidden: true,
  isError: false,
  message: '',
};

export enum SIGNUP_STEPS {
  USER_DETAILS,
  ENTITY_DETIALS,
  OTP,
}
